export default __webpack_public_path__ + "static/media/m20.dba71f6d.jpg";